module.exports = __webpack_public_path__ + "static/media/safeway.f88cdc9d.svg";